export default "__VITE_ASSET__349t7Q7e__"